<p>deactivate-profile works! {{currentUser.userId}}</p>
